const isTokenSaved = () => localStorage.getItem('isUserLogged');

export default isTokenSaved;
